import * as UsersActions from "./users"
import * as AccountActions from "./account"

export const ActionCreators = Object.assign({}, UsersActions, AccountActions)



// WEBPACK FOOTER //
// ./src/redux/actions/index.js